{
  "00945c89f76b547f": "Calificación",
  "084589b75f7b2594": "Pasado, no lleno",
  "0cbbed3d4fb3b62d": "Las direcciones de origen y destino no coinciden. El backend rechazará la migración a menos que las direcciones sean compatibles.",
  "19766ed6ccb2f4a3": "Cancelar",
  "1af379f2d2ceaa59": "Confirmar migración",
  "234c7002b7c8b66f": "Migrar turnos",
  "34a078687bb02ed2": "La migración no se aplicó. Intente nuevamente y ejecute una nueva vista previa.",
  "3a60e59aa097fe17": "Finalización efectiva (opcional)",
  "417a6b7e1904940a": "Pendiente de verificación",
  "44379762f7964194": "Empieza pronto",
  "46701bfc2e78c6e7": "Total migrable",
  "47c2df10559485d2": "Vista previa de la migración",
  "4a49935a4ea295b9": "Lugar de trabajo de origen",
  "4bd00ad4ed1bf62d": ", comenzando",
  "4f7838402f37674e": "Verificado",
  "511ed0936645a3a8": "La migración falló",
  "57393f549b1117cb": "Total ignorado",
  "57a0b86121d762e9": "Migración completada con éxito.",
  "59b75a09ad8728b6": "Turnos migrados",
  "6031ee797185af1e": "Comienza a escribir el nombre del lugar de trabajo...",
  "62f9a7361a1252e3": "Volver a parámetros",
  "663ea1bfffe5038f": "a",
  "76900f1bfd16c8d4": "Volver",
  "7d9eb7acb13e2462": "Cerrar",
  "80ea6bf00677e9ab": "Calificación: {{qualification}}",
  "87c06b34aacdedef": "Migrando turnos desde",
  "910e12c594caf689": "Inicio efectivo",
  "95c31eb9f2200e41": "Lugar de trabajo de destino",
  "9c6725dc269a48ce": "a través de",
  "9d8979e11fdead7a": "nombre,idUsuario,direcciónCompleta",
  "9facfbe860f996cb": "Todos los turnos dentro de la ventana son elegibles para ser migrados.",
  "a242d79c57459c69": "Limitar la migración a una sola calificación, o migrar todas las calificaciones.",
  "a903eee3da327410": "Migración completa",
  "c9b3c38247f744e1": "Total",
  "cc2111dd92b635db": "Buscando lugares de trabajo...",
  "da50017b4af59e26": "Cualquier calificación",
  "e52e45d02310f868": "Los turnos no verificados no pueden ser migrados a menos que comiencen más de 4 horas en el futuro.",
  "e87ced5e089eba2b": "ID: {{id}}",
  "ed077f3d8125d60d": "Abierto",
  "efb1b9fb7d251ac7": "Dirección no disponible",
  "f15ae52605d8cb6e": "Calificación: Cualquiera",
  "f7476d9ec6213488": "Turnos a migrar",
  "fd1331d7a6cd0309": "Reservado",
  "ffc3898a1161a769": "Turnos que se ignorarán"
}
